import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { CallbackComponent } from './login/callback/callback.component';
import { SignupComponent } from './login/signup/signup.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { CondominiumComponent } from './condominium/condominium.component';
import { CommunicationsComponent } from './communications/communications.component';
import { CreateComponent } from './condominium/create/create.component';
import { AuthGuard } from './guards/auth.guard';
import { TaskDetailComponent } from './task/task-detail/task-detail.component';
import { TaskCreateComponent } from './task/task-create/task-create.component';
import { TasksAllComponent } from './task/tasks-all/tasks-all.component';
import { TicketDetailComponent } from './ticket/ticket-detail/ticket-detail.component';
import { TicketCreateComponent } from './ticket/ticket-create/ticket-create.component';
import { TicketsAllComponent } from './ticket/tickets-all/tickets-all.component';
import { CommunicationDetailsComponent } from './communications/communication-details/communication-details.component';
import { CondominiumLayoutComponent } from './condominium/condominium-layout/condominium-layout.component';
import { AllComponent } from './invitation/all/all.component';
import { InvitationCreateComponent } from './invitation/invitation-create/invitation-create.component';
import { InvitationResponseComponent } from './invitation/invitation-response/invitation-response.component';
import { ProfileComponent } from './profile/profile.component';
import { RegistrationComponent } from './condominium/registration/registration.component';
import { MembersComponent } from './condominium/members/members.component';
import { InfoComponent } from './condominium/info/info.component';
import { ChangeOwnerComponent } from './condominium/change-owner/change-owner.component';
import { CondominiumSubscriptionComponent } from './condominium/condominium-subscription/condominium-subscription.component';
import { CondominiumPaymentsComponent } from './condominium/condominium-payments/condominium-payments.component';
import { EmailConfirmationComponent } from './email-confirmation/email-confirmation.component';
import { EmailConfirmationReminderComponent } from './email-confirmation-reminder/email-confirmation-reminder.component';

const routes: Routes = [
  { path: '', component: HomeComponent, pathMatch: 'full' },
  { path: 'email-confirmation/:activationKey', component: EmailConfirmationComponent, canActivate: [AuthGuard] },
  { path: 'email-confirmation-reminder', component: EmailConfirmationReminderComponent, canActivate: [AuthGuard] },
  { path: 'condominiums', component: CondominiumComponent, canActivate: [AuthGuard] },
  { path: 'condominium/create', component: CreateComponent, canActivate: [AuthGuard] },
  { 
    path: 'condominium/:id', 
    component: CondominiumLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'dashboard', component: DashboardComponent },
      { path: 'communications', component: CommunicationsComponent },
      { path: 'communications/:commId', component: CommunicationDetailsComponent },
      { path: 'subscription', component: CondominiumSubscriptionComponent },
      { path: 'payments', component: CondominiumPaymentsComponent },
      { path: 'task/create', component: TaskCreateComponent },
      { path: 'task/:taskId', component: TaskDetailComponent },
      { path: 'tasks', component: TasksAllComponent },
      { path: 'ticket/create', component: TicketCreateComponent },
      { path: 'ticket/:ticketId', component: TicketDetailComponent },
      { path: 'tickets', component: TicketsAllComponent },
      { path: 'invitations', component: AllComponent },
      { path: 'invitation/create', component: InvitationCreateComponent },
      { path: 'registration', component: RegistrationComponent },
      { path: 'members', component: MembersComponent },
      { path: 'info', component: InfoComponent },
      { path: 'change-owner', component: ChangeOwnerComponent },
    ]
  },
  { path: 'condominiums/invitation/:invitationId', component: InvitationResponseComponent, canActivate: [AuthGuard] },
  { path: 'signup', component: SignupComponent },
  { path: 'profile', component: ProfileComponent, canActivate: [AuthGuard] },
  { path: 'callback', component: CallbackComponent },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
